const defaultState = {
    headerHeight: 54,
    language: localStorage.getItem('@markidim:language') || 'he',
}

const appReducer = (state = defaultState, action) => {
    // console.log("app reducer action = ", action)

    switch (action.type) {
        case 'SET_LANGUAGE':
            return {...state, language: action.language}

        case 'SET_APP_CONFIG':
            return Object.assign({}, state, {
                headerHeight: action.appConfig,
            })

        default:
            return state
    }
}

export default appReducer
